import type { ReactNode } from 'react';
import {
  paymentBadgeClass,
  statusBadgeClass,
  statusLabel,
  type ClaimStatus,
  type PaymentStatus,
} from '@gdec/shared';

export function Badge({
  className,
  children,
}: {
  className: string;
  children: ReactNode;
}): ReactNode {
  return <span className={`badge ${className}`}>{children}</span>;
}

export function StatusBadge({ status }: { status: ClaimStatus }): ReactNode {
  return <Badge className={statusBadgeClass(status)}>{statusLabel(status)}</Badge>;
}

export function PaymentBadge({ status }: { status: PaymentStatus | '' }): ReactNode {
  return <Badge className={paymentBadgeClass(status)}>{status || '—'}</Badge>;
}
